import React, { useEffect, useState } from "react";
import api from "../../api";
import Delete from "../../images/delete.svg";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import copy from "copy-to-clipboard";
import './AdminDashboard.css'

function WalletUsers({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const getUsers = async () => {
    try {
      let payload = { page: page };
      setLoader(true);
      const userData = await api.allWalletUsers(payload);
      setData(userData.user);
      setnoOfUser(userData.count);
      setLimit(userData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deleteUser = async (id) => {
    try {
      let payload = { id: id };
      setLoader(true);
      const userData = await api.deleteUser(payload);
      console.log("deleted");
      getUsers();
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = { email: searchMail };
      const res = await api.getUserByMail(payload);
      if (res?.success) {
        setData(res?.user);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  useEffect(() => {
    getUsers();
  }, [page, resetPage]);

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="wallet-users-management-wrapper">
              {/* Header Section */}
              <div className="wallet-users-header-section mb-5">
                <div className="wallet-users-header-content">
                  <div className="wallet-users-title-section">
                    <h1 className="wallet-users-main-title">
                      <i className="fas fa-wallet wallet-users-title-icon me-3"></i>
                      Wallet Users Management
                    </h1>
                    <p className="wallet-users-subtitle">
                      Manage users with wallet addresses and cryptocurrency transactions
                    </p>
                  </div>
                  
                  {/* Search and Reset Section */}
                  <div className="wallet-users-search-section">
                    <div className="wallet-users-search-container">
                      <div className="wallet-users-search-input-wrapper">
                        <i className="fas fa-search wallet-users-search-icon"></i>
                        <input
                          type="text"
                          className="wallet-users-search-input"
                          placeholder="Search wallet users by email address..."
                          value={searchMail}
                          onChange={(e) => setSearchMail(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                        />
                        {searchMail && (
                          <button 
                            className="wallet-users-search-clear"
                            onClick={() => setSearchMail("")}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                      <button 
                        className="wallet-users-search-btn"
                        onClick={handleSearch}
                      >
                        <i className="fas fa-magnifying-glass me-2"></i>
                        Search
                      </button>
                    </div>
                    <button 
                      className="wallet-users-reset-btn"
                      onClick={handleReset}
                    >
                      <i className="fas fa-arrows-rotate me-2"></i>
                      Reset Filters
                    </button>
                  </div>
                </div>
                
                {/* Stats Cards */}
                <div className="wallet-users-stats-container">
                  <div className="wallet-users-stat-card">
                    <div className="wallet-users-stat-icon total-wallet-users">
                      <i className="fas fa-wallet"></i>
                    </div>
                    <div className="wallet-users-stat-content">
                      <h3 className="wallet-users-stat-number">{noOfUser}</h3>
                      <p className="wallet-users-stat-label">Total Wallet Users</p>
                    </div>
                  </div>
                  {/* <div className="wallet-users-stat-card">
                    <div className="wallet-users-stat-icon verified-wallets">
                      <i className="fas fa-user-check"></i>
                    </div>
                    <div className="wallet-users-stat-content">
                      <h3 className="wallet-users-stat-number">
                        {data.filter(user => user?.emailVerified).length}
                      </h3>
                      <p className="wallet-users-stat-label">Verified Users</p>
                    </div>
                  </div> */}
                  <div className="wallet-users-stat-card">
                    <div className="wallet-users-stat-icon active-wallets">
                      <i className="fas fa-coins"></i>
                    </div>
                    <div className="wallet-users-stat-content">
                      <h3 className="wallet-users-stat-number">
                        {data.filter(user => user?.wallet && user.wallet.trim() !== "").length}
                      </h3>
                      <p className="wallet-users-stat-label">Active Wallets</p>
                    </div>
                  </div>
                  <div className="wallet-users-stat-card">
                    <div className="wallet-users-stat-icon recent-wallets">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <div className="wallet-users-stat-content">
                      <h3 className="wallet-users-stat-number">
                        {data.filter(user => {
                          const oneMonthAgo = new Date();
                          oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
                          return new Date(user.createdAt) > oneMonthAgo;
                        }).length}
                      </h3>
                      <p className="wallet-users-stat-label">Last 30 Days</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table Section */}
              <Table
                data={data}
                setPage={setPage}
                page={page}
                noOfUser={noOfUser}
                limit={limit}
                deleteUser={deleteUser}
              />
            </div>
          </div>
        </div>
      </div>
      
      {loader && <Loader />}

      {/* Styles */}
      <style jsx>{`
        
      `}</style>
    </>
  );
}

const Table = ({ data, page, setPage, noOfUser, limit, deleteUser }) => {
  const [copyText, setCopyText] = useState("");

  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleCopy = (text, index) => {
    copy(text);
    setCopyText(index);
    setTimeout(() => {
      setCopyText("");
    }, 3000);
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Joined At
                  </th>
                  <th scope="col" className="">
                    Name
                  </th>
                  <th scope="col" className="">
                    Email
                  </th>
                  <th scope="col" className="">
                    Phone
                  </th>
                  <th scope="col" className="">
                    Wallet
                  </th>
                  <th scope="col" className="">
                    country
                  </th>
                  <th scope="col" className="">
                    DOB
                  </th>
                  <th scope="col" className="">
                    Gender
                  </th>
                  <th scope="col" className="">
                    <div className="w-max-c">Email verified</div>
                  </th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.name}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.email}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.phone ? item?.phone : "-"}
                      </span>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.wallet ? (
                          <>
                            <span className="wallet-address">
                              {item?.wallet}
                            </span>
                            <span className="copyToClip" title="Copy wallet address">
                              <i
                                onClick={() => handleCopy(item?.wallet, key)}
                                className="fa-regular fa-copy cursor-pointer me-1"
                              ></i>
                              {copyText === key ? "Copied!" : "Copy"}
                            </span>
                          </>
                        ) : (
                          "-"
                        )}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.country ? item?.country : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.dob}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.gender}
                      </span>
                    </td>
                    <td>
                      {item?.emailVerified ? (
                        <span className="badge bg-success w-max-c db">
                          verified
                        </span>
                      ) : (
                        <span className="badge bg-danger w-max-c db">
                          not verified
                        </span>
                      )}
                    </td>
                    <td>
                      <div className="mr-5">
                        <a href="#" onClick={() => deleteUser(item?._id)}>
                          <img src={Delete} alt="Delete" />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center mt-4">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfUser / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletUsers;